module.exports = __webpack_public_path__ + "img/lxwm.a4959806.png";